var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-content',[(_vm.isLoggedIn)?_c('v-logged-in-base-tool-bar',{on:{"sign-out-button-click":_vm.signOut}}):_vm._e(),(_vm.isLoggedIn)?_c('router-view'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }